export default __webpack_public_path__ + "static/media/wi_5.888c00c4.mp3";